import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
// import vars, { outlineButton } from "@exo/narrative-tracker-variables";
// import { smallCaps } from "@exo/style-mixins";

const SpinnerBox = styled.div`
	height: 100%;
	transform: ${(props) => (props.scale ? `scale(${props.scale})` : "")};
`;

const RoundSpinner = (props) => {
	return (
		<SpinnerBox scale={props.scale}>
			<div className="round-spinner">
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-1" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-2" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-3" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-4" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-5" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-6" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-7" />
				<div style={{ backgroundColor: props.color }} className="round-spinner__ball-8" />
			</div>
		</SpinnerBox>
	);
};

RoundSpinner.defaultProps = {
	color: "#000000",
	scale: false,
};

RoundSpinner.propTypes = {
	scale: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
	color: PropTypes.string,
};

export default RoundSpinner;
